<div #chatContainer class="overflow-y-auto flex-fill page-container">
  <div id="chat-container" class="container">
  <div class="flex-column flex-fill d-flex mx-2">
    <ng-container *ngFor="let chatMessage of messages; let i = index">
      <div class="w-100 d-flex" [ngStyle]="{'justify-content' : chatMessage.role !== role.Assistant ? 'end' : ''}">
        <div [id]="'chat-msg-' + i" class="border-1 chat-msg"  (mouseenter)="currentMessageNumber = i" (mouseleave)="currentMessageNumber = null"
             [ngClass]="{'ai-msg' : chatMessage.role === role.Assistant, 'err-msg' : aiResponseError && i === messages.length - 1}">
          <ng-container *ngIf="showSendAgain(i); else message">
            <div class="d-flex" [ngStyle]="{'justify-content': aiResponseError ? 'space-between' : 'end'}">
              <i *ngIf="aiResponseError" class="fa-solid fa-triangle-exclamation" style="color: red"></i>
              <i *ngIf="!chatViewService.promptViolation" class="fa-solid fa-arrow-rotate-right"
                 [ngClass]="{'send-again-error': aiResponseError, 'send-again-stopped blue-400': chatViewService.stopped }"
                 (click)="resend()" pTooltip="Send again"></i>
            </div>
            <div [innerHTML]="getFormattedTextareaValue(chatMessage.message)"></div>
          </ng-container>
          <ng-template #message>
            <ng-container *ngIf="chatMessage.role === role.Assistant">
              <div class="d-flex">
                <div class="markdown-container">
                  <markdown katex [katexOptions]="katexOptions" mermaid clipboard [data]="(chatMessage.message)"></markdown>
                </div>
                <div *ngIf="!aiTypingResponse || chatMessage.completed" class="ms-2">
                  <div class="d-flex justify-content-end">
                    <i class="fa-regular fa-copy" style="color: var(--primary-color)"
                       (click)="copyToClipboard(chatMessage.message)" pTooltip="Copy"></i>
                  </div>
                </div>
              </div>
            </ng-container>
            <div *ngIf="chatMessage.role === role.Assistant && hasUsedCitation(chatMessage)"
                 class="mt-2 d-flex flex-wrap">
              <div class="fw-bold me-1 d-flex align-items-center">Citations:</div>
              <ng-container *ngFor="let cit of chatMessage.citations">
                <div *ngIf="cit.used" class="citation">
                  <a *ngIf="!cit.local" [href]="cit.url" target="_blank">{{cit.index + ". " + cit.title | slice:0:maxLengthOfCitationTitle}} {{ cit.title.length > maxLengthOfCitationTitle ? '...' : '' }}</a>
                  <a *ngIf="cit.local" href="#" (click)="downloadFileFromAzure(cit,$event)">{{cit.index + ". " + cit.title | slice:0:maxLengthOfCitationTitle}} {{ cit.title.length > maxLengthOfCitationTitle ? '...' : '' }}</a>
                </div>
              </ng-container>

            </div>
            <div *ngIf="chatMessage.role !== role.Assistant"
                 [innerHTML]="getFormattedTextareaValue(chatMessage.message)">
            </div>
            <div *ngIf="chatMessage.files?.length > 0" class="mt-2 d-flex flex-wrap">
              <div class="fw-bold me-1 d-flex align-items-center">Files:</div>
              <ng-container *ngFor="let file of chatMessage.files; let index = index">
                <div class="citation">
                  {{index + 1 + ". " + file | slice:0:maxLengthOfCitationTitle}} {{ file.length > maxLengthOfCitationTitle ? '...' : '' }}
                </div>
              </ng-container>
            </div>
            <div *ngIf="chatMessage.codeFiles?.length > 0" class="mt-2 d-flex flex-wrap">
              <div class="fw-bold me-1 d-flex align-items-center">Code interpreters:</div>
              <ng-container *ngFor="let file of chatMessage.codeFiles; let index = index">
                <div class="citation">
                  {{index+1 + ". " + file | slice:0:maxLengthOfCitationTitle}} {{ file.length > maxLengthOfCitationTitle ? '...' : '' }}
                </div>
              </ng-container>
            </div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="aiTypingResponse && chatMessage.role !== role.Assistant && i === messages.length - 1"
           class="w-100 d-flex"
      >
        <div class="border-1 ai-msg">
          <span class="typing-indicator"></span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
</div>
